<template>
  <div class="homocycle-ratio-warp" v-loading="loading">
    <el-row :gutter="20" class="h-100" v-if="obj">
      <el-col class="h-100 el-col">
        <div class="box defalt-color bg-blue-color v2-box-1">
          <div class="item-title">
            <label class="icon bg-defalt-color blue-color">
              <i class="el-icon-share"></i>
            </label>
            当前用量（{{unit}}）
          </div>
          <div class="item-value">
            <label v-if="obj[''+type].value === ''">-</label>
            <countTo v-else :startVal="0" :endVal="parseFloat(obj[''+type].value)" :decimals="2" :duration="1000"></countTo>
          </div>
          <div class="item-foot">
            <div class="item-foot-left">
              同比：{{obj[''+type].YoYTrend || 0}}%

              <div class="icon-item" v-if="obj[''+type].YoYTrend>0">
                <i class="el-icon-top" style="color:red"></i>
              </div>
              <div class="icon-item" v-else-if="obj[''+type].YoYTrend < 0">
                <i class="el-icon-bottom" style="color:#04b39c"></i>
              </div>
              <div class="icon-item" style="color:#0097ee" v-else>
                =
              </div>
            </div>
            <div class="item-foot-right">
              环比：{{obj[''+type].MoMTrend || 0}}%
              <div class="icon-item" v-if="obj[''+type].MoMTrend>0">
                <i class="el-icon-top" style="color:red"></i>
              </div>
              <div class="icon-item" v-else-if="obj[''+type].MoMTrend < 0">
                <i class="el-icon-bottom" style="color:#04b39c"></i>
              </div>
              <div class="icon-item" style="color:#0097ee" v-else>
                =
              </div>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="4.8" class="h-100 el-col">
        <div class="box defalt-color bg-green-color v2-box-2">
          <div class="item-title">
            <label class="icon bg-defalt-color green-color">
              <i class="el-icon-share"></i>
            </label>
            同期用量（{{unit}}）
          </div>
          <div class="item-value">
            <label v-if="obj[''+type].Yoyvalue === undefined">-</label>
            <countTo v-else :startVal="0" :endVal="parseFloat(obj[''+type].Yoyvalue)" :decimals="2" :duration="1000"></countTo>
          </div>
          <div class="item-foot"></div>
        </div>
      </el-col>
      <el-col :span="4.8" class="h-100 el-col">
        <div class="box defalt-color bg-cyan-color v2-box-3">
          <div class="item-title">
            <label class="icon bg-defalt-color cyan-color">
              <i class="el-icon-share"></i>
            </label>
            同比趋势（%）
          </div>
          <div class="item-value">
            <label v-if="obj[''+type].YoYTrendPercent === undefined">-</label>
            <countTo v-else :startVal="0" :endVal=" parseFloat(obj[''+type].YoYTrendPercent)" :decimals="2" :duration="1000"></countTo>
          </div>
          <div class="item-foot"></div>
        </div>
      </el-col>
      <el-col :span="4.8" class="h-100 el-col">
        <div class="box defalt-color bg-orange-color v2-box-4">
          <div class="item-title">
            <label class="icon bg-defalt-color orange-color">
              <i class="el-icon-share"></i>
            </label>
            环期用量（{{unit}}）
          </div>
          <div class="item-value">
            <label v-if="obj[''+type].MoMvalue === ''">-</label>
            <countTo v-else :startVal="0" :endVal="parseFloat(obj[''+type].MoMvalue)" :decimals="2" :duration="1000"></countTo>
          </div>
          <div class="item-foot"></div>
        </div>
      </el-col>
      <el-col :span="4.8" class="h-100 el-col">
        <div class="box defalt-color bg-orange-color v2-box-5">
          <div class="item-title">
            <label class="icon bg-defalt-color orange-color">
              <i class="el-icon-share"></i>
            </label>
            环比趋势（%）
          </div>
          <div class="item-value">
            <label v-if="obj[''+type].MoMTrendPercent === ''">-</label>
            <countTo v-else :startVal="0" :endVal="parseFloat(obj[''+type].MoMTrendPercent)" :decimals="2" :duration="1000"></countTo>
          </div>
          <div class="item-foot"></div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import countTo from "vue-count-to";
import api from "../../../../../common/api/index";
import dayjs from 'dayjs'

export default {
  props: {
    unit: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "water"
    }
  },
  data () {
    return {
      loading: true,
      obj: null
    };
  },
  components: { countTo },
  methods: {
    async getData (obj) {
      if (!obj.measureId) {
        return;
      }
      let vm = this;

      vm.loading = true;
      const params = {
        measureId: obj.measureId,
        startTime: obj.startTime.replace(/-/g, '/'),
        endTime: obj.endTime.replace(/-/g, '/'),
        segments: [],
        pointCode: 100401,
        pointNumber: 0
      }
      const getParams = isQOQ => {
        const o = {
          ...params,
          startTime: dayjs(obj.startTime)
          .subtract(1, isQOQ ? obj.timeType : 'year')
          .format('YYYY/MM/DD 00:00:00'),
          endTime: dayjs(obj.endTime)
          .subtract(1, isQOQ ? obj.timeType : 'year')
          .format('YYYY/MM/DD 23:59:59')
        }
        if (obj.timeType === 'month') {
          o.endTime = dayjs(o.startTime).add(1, obj.timeType).subtract(1, 'day')
          .format('YYYY/MM/DD 23:59:59')
        }
        return o
      }
      if (obj.timeType !== 'day') delete params.segments
      const type = obj.timeType[0].toLocaleUpperCase() + obj.timeType.slice(1)
      const fn = api.quantity[`getQuantity${type}`]
      const valueObj = {
        [this.type]: {}
      }
      const [res, res1, res2] = await Promise.all([
        fn(...Object.values(params)),
        fn(...Object.values(getParams())),
        fn(...Object.values(getParams(true))),
      ])
      const getResData = (resData) => {
        return obj.timeType === 'day' ? resData.data[0] : resData.data
      }
      if (res.success && getResData(res).length) {
        valueObj[this.type].value = getResData(res)[0].value
      }
      if (res1.success && getResData(res1).length) {
        valueObj[this.type].Yoyvalue = getResData(res1)[0].value
        const v = ((valueObj[this.type].value - getResData(res1)[0].value) / getResData(res1)[0].value * 100)
        valueObj[this.type].YoYTrend = v ? v.toFixed(2) : 0
      }
      if (res2.success && getResData(res2).length) {
        valueObj[this.type].MoMvalue = getResData(res2)[0].value
        const v = valueObj[this.type].MoMTrendPercent = ((valueObj[this.type].value - getResData(res2)[0].value) / getResData(res2)[0].value * 100)
        valueObj[this.type].MoMTrend = v ? v.toFixed(2) : 0
      }
      this.obj = valueObj
      vm.loading = false
    }
  }
};
</script>

<style lang="scss" scoped>
.homocycle-ratio-warp {
  width: 100%;
  height: 100%;
  .box {
    display: flex;
    flex-flow: column;
    padding: 0px 4px;
    box-sizing: border-box;
    .item-title {
      height: 30px;
      line-height: 30px;
      display: flex;
      align-items: center;
      font-weight: bold;
    }
    .item-value {
      flex: 1;
      font-size: 28px;
      text-align: center;
      display: flex;
      font-weight: bold;
      align-items: center;
      white-space: normal;
      justify-content: center;
    }
    .item-foot {
      display: flex;
      height: 30px;
      line-height: 30px;
      div {
        flex: 1;
      }
      .item-foot-right {
        text-align: right;
      }
    }
  }
}
.icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  border-radius: 16px;
  margin-right: 4px;
  text-align: center;
  line-height: 20px;
}
.h-100 {
  height: 100%;
}
.el-col {
  width: 20%;
}
.icon-item {
  width: 16px;
  height: 16px;
  border-radius: 8px;
  background: #fff;
  display: inline-block;
  line-height: 16px;
  text-align: center;
}
</style>
